<app-ehe-header [auth]="true"></app-ehe-header>
<section class="health-coach-wrapper general-wrapper">
	<div class="row coaching-wrapper-header">
		<h1 class="w-100">Welcome {{ this.userName }}</h1>
		<h2 class="w-100" [translate]="'health-coach.sections.wellness.header.next-steps'">Your next steps</h2>
		<mat-divider class="w-100 mb-3"></mat-divider>
	</div>
	<!-- Post Exam Coaching appointment Confirmation-->
	<div class="row coaching-wrapper-appointment mb-4" *ngIf="showHealthMentorAppointmentTile">
		<app-post-exam-coaching-tile> </app-post-exam-coaching-tile>
	</div>
	<div class="row coaching-wrapper-appointment mb-4" *ngIf="!showHealthMentorAppointmentTile && eligibleForPE">
		<app-coaching-appointment
			[eligibleForPE]="eligibleForPE"
			[eligibleForHM]="eligibleForHM"
			[hasFutureConfirmedAppt]="hasFutureConfirmedAppt">
		</app-coaching-appointment>
	</div>
</section>
<app-ehe-footer [socialNetwork]="true"></app-ehe-footer>
<app-ehe-spinner></app-ehe-spinner>
